export function buildPageTitle(parts: string[], portalTitle: string) {
  return [...parts, portalTitle].filter(Boolean).join(' | ')
}